import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import "../next/SetNext.css"
function ContainerExample() {
  return (
    <Container>
      <Row style={{justifyContent : 'end'}}>
        <Col lg={3}>
          <div className='nextbt ' >
              <Button variant="success">1</Button>
              <Button variant="success">2</Button>
              <Button variant="success">3</Button>
            <div className='next-page-icon btn-success btn'>
                <i class="fa-solid fa-angle-right"></i>
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  );
}

export default ContainerExample;